export function toPascal(string: string): string {
  const pascalString = string
    ?.replace(/_/g, '-')
    ?.split('-')
    ?.map((substr) => substr.charAt(0).toUpperCase() + substr.slice(1))
    ?.map((substr) => fixDoubleUppercase(substr))
    ?.join('')

  return fixDoubleUppercase(pascalString)
}

function fixDoubleUppercase(str: string): string {
  // Replace any sequence of two or more uppercase letters with first as is, rest as lowercase
  return str.replace(
    /([A-Z])([A-Z]+)/g,
    (_, first, rest) => first + rest.toLowerCase()
  )
}

export function toDashes(string: string): string {
  return string
    ?.replace(/(?!^)([A-Z])/g, '-$1')
    ?.toLowerCase()
    ?.replace(/[\s_,;:]+/g, '-')
    ?.replace(/-+/g, '-')
}

function randomNumber(): number {
  return crypto.getRandomValues(new Uint32Array(1))[0]
}

function randomID(): string {
  return [...Array(4)].map(() => randomNumber().toString(16)).join('')
}

export function createCorrelationId(): string {
  return `${randomID()}+${new Date().toISOString()}`
}
